import post from './post';
import configuration from '../configuration';

const postConfiguration = async (client, config, configExternalId = config.configExternalId) => {
  const baseConfig = configuration();
  const project = baseConfig.project;
  const baseUrl = baseConfig.baseUrl;
  const path = configuration().restPath;
  const messageBody = {
    purpose: 'config',
    config,
    configExternalId,
    project,
    baseUrl
  };
  return post(path, client, JSON.parse(JSON.stringify(messageBody)));
};
export default postConfiguration;